// ==================================================
// MARKETING: Edit homepage content here
// ==================================================

export const homeHero = {
  headline: 'Predict Property Values with AI',
  subheadline: 'Make smarter investment decisions with AI-powered property forecasting',
  ctaText: 'Get Started Free',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
  image: '/images/hero-placeholder.png', // Replace with actual image
}

export const homeFeatures = [
  {
    title: 'Accurate Forecasts',
    description: 'AI analyzes years of market data to predict future property values',
    icon: '📊',
  },
  {
    title: 'Market Insights',
    description: 'Get detailed insights into market trends and opportunities',
    icon: '💡',
  },
  {
    title: 'Easy to Use',
    description: 'Simple interface that anyone can understand and use',
    icon: '✨',
  },
]

export const homeCTA = {
  headline: 'Ready to get started?',
  subheadline: 'Join thousands of investors making smarter decisions',
  ctaText: 'Start Free Trial',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
}
